import { render, staticRenderFns } from "./SelectWaresDrug.vue?vue&type=template&id=76baf41e&scoped=true&"
import script from "./SelectWaresDrug.vue?vue&type=script&lang=js&"
export * from "./SelectWaresDrug.vue?vue&type=script&lang=js&"
import style0 from "./SelectWaresDrug.vue?vue&type=style&index=0&id=76baf41e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76baf41e",
  null
  
)

export default component.exports